import { BaseSyntheticEvent, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { emailValidateion } from "../../../common/Valitation";
import { OnsiteTextField } from "../../../customelements/CustomInput";
import { HttpPostData, JumpPage } from "../../../common/Util";
import { ResponseParamBase } from "../../../common/Types";
import { MessageParam } from "../../Message";
import { TitleParamContext } from "../../../context/TitleContext";
import market from "../../../css/market.module.scss";
import base from "../../../css/base.module.css";

//パスワード変更画面

export interface IFormInputs {
    maillAddress: string
}

export type ResponseParam = ResponseParamBase & {

}

const schema = Yup.object({
    maillAddress: emailValidateion
}).required();

export const ForgetPassword = () => {
    const { register, handleSubmit, control, formState: { errors, isValid } } = useForm<IFormInputs>({
        defaultValues: {
            maillAddress: ""
        },
        resolver: yupResolver(schema),
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const navigate = useNavigate();
    const titleContext = useContext(TitleParamContext);
    const [result, setResult] = useState<ResponseParam>({ resultFlg: false, message: "" });
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        titleContext.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "パスワード変更", secondSubTitle: "" });
    }, []);

    const onSubmit: SubmitHandler<IFormInputs> = async (data: IFormInputs, event?: BaseSyntheticEvent) => {
        await HttpPostData<ResponseParam>("/UserManager/ForgetPassword", { email: data.maillAddress }, setIsLoading)
            .then(response => {
                if (response.status == 200 && response.data.resultFlg) {
                    JumpPage<MessageParam>("Message", { message: response.data.message, displayButton: false }, "", navigate);
                } else {
                    setResult(response.data);
                }
            })
            .catch(e => {
                console.log(e);
            })
    }

    return (
        <>
            <form onSubmit={(e) => { handleSubmit(onSubmit)(e) }}>
                <section className={market.marketArea}>
                    <div className={base.centerContents}>指定のメールアドレスに送付されたメールに記載されているURLから、パスワードの変更を行ってください。</div>
                    <div className={market.marketAreaInner}>
                        <div className={market["layoutBox-l"]}>
                            <div className={market.marketInputTitle}>
                                <h3>メールアドレス</h3>
                            </div>
                            <div className={market.marketInputTitleContents}>
                                <Controller
                                    name="maillAddress"
                                    control={control}
                                    render={({ field }) => (
                                        <OnsiteTextField
                                            {...field}
                                            {...register}
                                            error={errors.maillAddress ? true : false}
                                            helperText={errors.maillAddress?.message}
                                            margin="normal"
                                            type="email"
                                        />
                                    )}
                                />
                            </div>
                        </div>
                        <div className={base.errorMessage}>{result.message}</div>
                        <div className={market.marketFooterArea}>
                            <button className={market.marketBackButton} type="button" onClick={(e) => { JumpPage("/Login", {}, "", navigate); }}>戻る</button>
                            <button className={market.marketButton} type="submit" disabled={!isValid || isLoading}>送信</button>
                            <button style={{ visibility: "hidden" }} className={market.marketBackButton}>＜　進む</button>
                        </div>
                    </div>
                </section>
            </form>
        </>
    );
}